export const releaseNewsActionTypes = {
    STORE_RELEASE_NEWS: 'STORE_RELEASE_NEWS',
} as const;
